export default __webpack_public_path__ + "static/media/logo_zuzmi_alb_text.480061c1.png";